/**
 * Function that returns the template for the overlay
 * @returns {HTMLElement}
 */ export var overlayTemplate = function(onClick) {
    // create a div that works as an overlay for the tooltip
    // also add the styles for the overlay transparent background
    var overlay = document.createElement("div");
    overlay.classList.add("kmd-overlay");
    overlay.style.position = "fixed";
    overlay.style.top = "0";
    overlay.style.left = "0";
    overlay.style.width = "100%";
    overlay.style.height = "100%";
    overlay.style.backgroundColor = "rgba(27, 27, 29, 0.5)";
    overlay.style.zIndex = "1000";
    if (onClick) {
        overlay.onclick = onClick;
    }
    return overlay;
};
